// @flow
/* -------------------Third parties----------------------- */
import moment from 'moment';

/* -------------------Types----------------------- */
import { type CreateScheduleState } from './types';

/* -------------------Utils----------------------- */
import { CustomIntl } from '../utils';

const NO_TASKS_DUE_TODAY = 'No tasks due today';
const sessionMasteryModeLabel = {
  REMEMBERED: 'Remembered',
  NEWLY_LEARNED: 'Newly learned',
  FORGOTTEN: 'Forgotten',
};

const loadingTextSaveSchedule = [
  {
    icon: 'format-list-text',
    text: 'Retrieving content',
  },
  {
    icon: 'brain',
    text: 'Analyzing mastery',
  },
  {
    icon: 'calendar-clock',
    text: 'Setting goal date ',
  },
  {
    icon: 'timer-sand',
    text: 'Optimizing study time',
  },
  {
    icon: 'check-outline',
    text: 'Calculating today\'s task',
  },
];

const cardMasteryHeaderData = (
  answeredCount: number,
  type: string,
) => ({
  title: 'Today\'s Mastery',
  subtitle: `Based on ${answeredCount} unique ${type} reviewed from your scheduled tasks`,
});

const waitingTextScheduleOnBoarding = 'Creating your schedule might take a few minutes. In the meantime, feel free to browse the content. Once the schedule is fully created, refresh your dashboard to start studying!';
const waitingTextSchedule = 'Creating your schedule might take a few minutes. Once the schedule is fully created, refresh your dashboard to start studying!';

const initialState: CreateScheduleState = {
  id: null,
  title: 'Master this schedule',
  selectedContents: [],
  goalDate: null,
  isLongTerm: false,
  studyDuration: 30,
  addedContents: [],
  reminderTime: {
    hour: moment().hour(),
    minutes: 0,
    isAm: moment().format('A') === 'AM',
    timeZone: CustomIntl.timezone,
  },
  editMode: false,
  editContent: false,
  showDatePicker: false,
  showEditDate: false,
  showTimePicker: false,
  showEditTime: false,
  showLearningModal: false,
  showSlider: false,
  showDiscardModal: false,
  showContentDialog: false,
  date: null,
  time: moment().add(1, 'days').format('hh:00 A'),
  query: null,
  detailScheduleId: null,
  maxStudyDuration: 0,
  isArchived: false,
};

export {
  NO_TASKS_DUE_TODAY,
  initialState,
  sessionMasteryModeLabel,
  cardMasteryHeaderData,
  loadingTextSaveSchedule,
  waitingTextScheduleOnBoarding,
  waitingTextSchedule,
};
